import { render } from "./About.vue?vue&type=template&id=b3faae04"
const script = {}
script.render = render

export default script